import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../../_services/common.service';
import { HttpRequestService } from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';
@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {

  billingAddressForm:FormGroup;
  billingFormSubmitStatus:boolean = false;

  constructor(public translate: TranslateService, private cService: CommonService,
    private httpService: HttpRequestService, private toastr: ToastrService,
    private formBuilder:FormBuilder,
    private router:Router
  ) {
    this.cService.activelang.subscribe((lang) => {

      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }
  countryList:Array<any> = [];
  cityShippingList:Array<any> = [];
  cityBillingList:Array<any> = [];
  ngOnInit() {
    let userDetails = this.cService.getLoginUserDetails();
    this.billingAddressForm = this.formBuilder.group({
      "user_id":[userDetails.id],
      "id":[""],
      "shipping_adress_country_id": [null, [Validators.required]],
      "shipping_address_city_id":[null, [Validators.required]],
      "shipping_address":['', [Validators.required]],
      "shipping_name": ['', [Validators.required]],
      "shipping_surname": ['', [Validators.required]],
      "shipping_state":['', [Validators.required]],
      "shipping_phone_no":['', [Validators.required,Validators.minLength(7),  Validators.maxLength(10)]],
      "shipping_zipcode":['', [Validators.required]],
      "billing_address_country_id":[null, [Validators.required]],
      "billing_address_city_id":[null, [Validators.required]],
      "billing_address":['', [Validators.required]],
      "billing_name": ['', [Validators.required]],
      "billing_surname": ['', [Validators.required]],
      "billing_state":['', [Validators.required]],
      "billing_phone_no":['', [Validators.required, Validators.minLength(7),  Validators.maxLength(10)]],
      "billing_zipcode":['', [Validators.required]],
    })
    this.httpService.setModule('action').post('shipping_billing_address_content', {}).subscribe((response) => {
      if (response.status == 'success') {
        this.countryList = response.data.country_list.map((i)=>{
          return {
            id:i.id,
            name:(i.local)?i.local[0].name:'',
            ccode:i.ccode
          }
        });
        // console.log(this.countryList);
      } else if (response.status=='error') {
        this.toastr.error( response.data,'Error:');
      }
    });
    if(localStorage.getItem('_current_shipping')) {
      this.httpService.setModule('action').post('shipping_billing_address_details',{
        address_id: localStorage.getItem('_current_shipping')
      }).subscribe((response) => {
        if (response.status == 'success') {
          this.billingAddressForm.setValue(
            {
              "user_id":userDetails.id,
              "id":localStorage.getItem('_current_shipping'),
              "shipping_adress_country_id": response.data.shipping_adress_country_id,
              "shipping_address_city_id":response.data.shipping_address_city_id,
              "shipping_address":response.data.shipping_address,
              "shipping_name": response.data.shipping_name,
              "shipping_surname":response.data.shipping_surname,
              "shipping_phone_no":response.data.shipping_phone_no,
              "shipping_zipcode": response.data.shipping_zipcode,
              "shipping_state": response.data.shipping_state,
              "billing_address_country_id":response.data.billing_address_country_id,
              "billing_address_city_id":response.data.billing_address_city_id,
              "billing_address":response.data.billing_address,
              "billing_name": response.data.billing_name,
              "billing_surname":response.data.billing_surname,
              "billing_phone_no":response.data.billing_phone_no,
              "billing_zipcode": response.data.billing_zipcode,
              "billing_state": response.data.billing_state,
            }
          );
          this.getCityFromCountry({id:this.billingAddressForm.value.shipping_adress_country_id}, 'shipping').then((resolveData)=>{
            this.billingAddressForm.controls['shipping_address_city_id'].setValue( response.data.shipping_address_city_id);
          });
          this.getCityFromCountry({id:this.billingAddressForm.value.billing_address_country_id}, 'billing').then((resolveData)=>{
            this.billingAddressForm.controls['billing_address_city_id'].setValue( response.data.billing_address_city_id);
          });
        }
        else if (response.status=='error') {
          this.toastr.error( response.data,'Error:');
        }
      });
    }
  }

  getCityFromCountry(e, type) {
    return new Promise((resolve, reject)=>{

      let countryId = e.id;
      this.httpService.setModule('action').post('shipping_city_by_country',{country_id:countryId,lang:localStorage.getItem('_lang')}).subscribe((response) => {

        if (response.status=='success') {
          let cityList = [];
          cityList = response.data.map((i)=>{
            return {
              id:i.id,
              name:i.name
            }
          });
          if (type == 'shipping') {
            this.cityShippingList = cityList
          }
          else if (type == 'billing') {
            this.cityBillingList = cityList
          }
        }
        if (response.status=='error') {
          this.toastr.error( response.data,'Error:');
        }
        resolve(true);
      }, (error) => {
        console.log(error);
      });
    })
  }

  setSameBillingAddress(e) {
    if (e.target.checked == true) {
      this.billingAddressForm.controls['billing_address_country_id'].setValue( this.billingAddressForm.value.shipping_adress_country_id);

      this.getCityFromCountry({id:this.billingAddressForm.value.shipping_adress_country_id}, 'billing').then((resolveData)=>{
        this.billingAddressForm.controls['billing_address_city_id'].setValue( this.billingAddressForm.value.shipping_address_city_id);
      });


      this.billingAddressForm.controls['billing_address'].setValue( this.billingAddressForm.value.shipping_address);

      this.billingAddressForm.controls['billing_name'].setValue( this.billingAddressForm.value.shipping_name);

      this.billingAddressForm.controls['billing_surname'].setValue(this.billingAddressForm.value.shipping_surname);

      this.billingAddressForm.controls['billing_state'].setValue( this.billingAddressForm.value.shipping_state);

      this.billingAddressForm.controls['billing_phone_no'].setValue(this.billingAddressForm.value.shipping_phone_no);


      this.billingAddressForm.controls['billing_zipcode'].setValue( this.billingAddressForm.value.shipping_zipcode);

    } else {
      this.billingAddressForm.controls['billing_address_country_id'].setValue( null);

      this.billingAddressForm.controls['billing_address_city_id'].setValue( null);

      this.billingAddressForm.controls['billing_address'].setValue( null);

      this.billingAddressForm.controls['billing_name'].setValue(null);

      this.billingAddressForm.controls['billing_surname'].setValue(null);

      this.billingAddressForm.controls['billing_state'].setValue( null);

      this.billingAddressForm.controls['billing_phone_no'].setValue( null);

      this.billingAddressForm.controls['billing_zipcode'].setValue(null);
    }
  }

  billingFormSubmit() {
    this.billingFormSubmitStatus = true;
    if (this.billingAddressForm.valid) {

      this.httpService.setModule('action').post('save_shipping_billing_address',this.billingAddressForm.value).subscribe((response) => {
        if (response.status == 'success') {
          if(!localStorage.getItem('_current_shipping')) {
            localStorage.setItem('_current_shipping', response.data.id );
          }
          this.translate.get([
            'SUCCESS',
            'ADDRESS_UPDATE_SUCCESS'
          ]).subscribe((tData) => {

            Swal.fire(tData['SUCCESS'], tData['ADDRESS_UPDATE_SUCCESS'], 'success')
            .then((result)=>{
              this.router.navigate(['/order','preview']);
            });
          })
        } else if (response.status=='error') {
          this.toastr.error( response.data,'Error:');
        }
      })
    }
  }
}
